import "bootstrap/dist/css/bootstrap.css";

export default function Synonyms(props) {
  const syn = props.data.synonyms;
  console.log(syn);
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  if (!syn) {
    return null;
  } else {
    return (
      <ul>
        {syn.map((synonyms, index) => (
          <li key={index}>{capitalize(synonyms)}</li>
        ))}
      </ul>
    );
  }
}
